import { NavLink } from "react-router-dom";
import { useState } from "react";
import Select from "react-select";
import { RiArrowDownSFill } from "react-icons/ri";

export default function Navbar() {
  const [Language, setLanguage] = useState({
    value: "EN",
    label: "EN",
  });
  const nav_class = ({ isActive }) =>
    isActive
      ? "flex items-start justify-start w-full h-full m-4 text-white text-base leading-4 font-base font-oswald bg-clip-text cursor-pointer transition-all duration-300"
      : "flex items-start justify-start w-full h-full m-4 text-white text-base leading-4 font-base font-oswald bg-clip-text ";
  return (
    <div className="flex w-full h-20 px-[8vw] justify-around items-center bg-[#0F2C49] drop-shadow">
      <div className="flex h-full" to="/">
        <img src="/logo.png" alt="" />
      </div>
      <nav className="flex items-center w-1/2 -translate-x-[10%]">
        <NavLink className={nav_class} to="/#home">
          HOME
          {/* <NavIcon img="" /> */}
        </NavLink>
        <NavLink className={nav_class} to="/#product">
          PRODUCTS
          {/* <NavIcon img="" /> */}
        </NavLink>
        <NavLink className={nav_class} to="/#strength">
          STRENGTH
          {/* <NavIcon img="" /> */}
        </NavLink>
        <NavLink className={nav_class} to="/#review">
          REVIEWS
          {/* <NavIcon img="" /> */}
        </NavLink>
        <NavLink className={nav_class} to="/">
          FAQ
          {/* <NavIcon img="" /> */}
        </NavLink>
        <NavLink className={nav_class} to="/">
          SERVICE
          {/* <NavIcon img="" /> */}
        </NavLink>
      </nav>
      <div className="flex flex-row h-full items-center justify-end overflow-visible relative">
        <NavLink className="h-10 w-10 m-4 translate-y-1/4" to="/">
          <svg
            viewBox="0 0 24 23"
            fill="white"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 21.5455C0 17.9305 2.9305 15 6.54545 15H17.4545C21.0695 15 24 17.9305 24 21.5455C24 22.3488 23.3488 23 22.5455 23H1.45455C0.651222 23 0 22.3488 0 21.5455Z"
              fill="#EAEAEA"
            />
            <path
              d="M19 6.5C19 10.0899 16.0899 13 12.5 13C8.91015 13 6 10.0899 6 6.5C6 2.91015 8.91015 0 12.5 0C16.0899 0 19 2.91015 19 6.5Z"
              fill="#EAEAEA"
            />
          </svg>
        </NavLink>
        <Select
          options={[
            {
              value: "EN",
              label: "EN",
            },
          ]}
          className="w-full rounded-md text-center text-black text-base"
          styles={{
            control: (base) => ({
              ...base,
              backgroundColor: "transparent",
              border: "1px solid white",
              color: "white",
            }),
            singleValue: (provided) => ({
              ...provided,
              color: "white",
            }),
            menu: (provided) => ({
              ...provided,
              backgroundColor: "white",
              zIndex: 9999,
            }),
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999,
            }),
            indicatorSeparator: () => ({
              display: "none",
            }),
            dropdownIndicator: (provided) => ({
              ...provided,
              padding: "0px",
              paddingRight: "4px",
            }),
            option: (provided) => ({
              ...provided,
              textTransform: "none",
            }),
          }}
          value={Language}
          onChange={(option) => setLanguage(option)}
          components={{
            DropdownIndicator: () => <RiArrowDownSFill />,
          }}
          menuPortalTarget={document.body}
          menuPosition="fixed"
          isSearchable={false}
        />
      </div>
    </div>
  );
}
